export const ENTITY_NAME = {
  PRODUCT_BOOK: "ProductBook",
};

export default ENTITY_NAME;
